import Embed from '@/embedded';
import TreeMap from './tree-map';
import {Store, Vuetify} from '@/shared';
import Vue from 'vue';

Embed.addContainerCustomElement();

Vue.customElement('tree-map', {
  ...TreeMap,
  store: Store,
  vuetify: Vuetify,
});
